export const maskValue = (mask: boolean | undefined, value: unknown): string => {
  if (value == null) {
    return '--';
  }
  const str = typeof value === 'string' ? value : String(value);
  if (!mask || str === '--' || str.length <= 4) {
    return str;
  }

  const last = str.slice(-4);
  const stars = '*'.repeat(str.length - 4);
  return `${stars}${last}`;
};
